{
  "breadcrumb": {
    "path": "databases > clients >",
    "all": "All"
  },
  "timeRanges": {
    "all": "All",
    "today": "Today",
    "15days": "15 days",
    "1month": "1 month",
    "3months": "3 months",
    "6months": "6 months",
    "1year": "1 year"
  },
  "table": {
    "columns": {
      "producto": "Product",
      "industria": "Industry",
      "fecha": "Date",
      "estatus": "Status",
      "cliente": "Client",
      "transaccion": "Transaction",
      "oper": "Operator"
    },
    "addButton": "Add operation",
    "searchPlaceholder": "Search operations...",
    "searchAriaLabel": "Search operations",
    "clearSearchAriaLabel": "Clear search",
    "prevDateAriaLabel": "Previous date",
    "nextDateAriaLabel": "Next date",
    "timeRangeAriaLabel": "Time range",
    "dateAriaLabel": "Date",
    "noPermission": "You don't have permission to view operations on this tab.",
    "loading": "Loading...",
    "emptyNoOps": "No operations",
    "emptyNoOpsFor": "No operations for \"{{search}}\"",
    "selectRowAriaLabel": "Select {{name}}",
    "archiveConfirm": "Are you sure you want to archive this client? It will disappear from all lists.",
    "archiveTitle": "Archive / Delete",
    "archiveAriaLabel": "Archive {{name}}",
    "operationFallback": "operation"
  },
  "permissions": {
    "searchPlaceholder": "Search user...",
    "searchAriaLabel": "Search user",
    "admin": "Admin"
  },
  "wizard": {
    "industryPlaceholder": "Industry...",
    "industryAriaLabel": "Industry",
    "clientSearchPlaceholder": "Search client...",
    "clientSearchAriaLabel": "Search client",
    "addClient": "+ Add \"{{name}}\"",
    "fullNamePlaceholder": "Full name",
    "emailPlaceholder": "Email address",
    "cancel": "Cancel",
    "create": "Create",
    "establishmentPlaceholder": "NAME OF THE RESTAURANT or establishment...",
    "establishmentAriaLabel": "Establishment name",
    "assignOperatorPlaceholder": "Assign operator...",
    "assignOperatorAriaLabel": "Assign operator",
    "back": "Back",
    "cancelWizard": "Cancel",
    "createUserError": "Error creating user"
  },
  "addModal": {
    "title": "+ New Operation",
    "transactionTitlePlaceholder": "Operation title *",
    "transactionTitleAriaLabel": "Operation title",
    "transactionRequired": "The operation title is required",
    "categoryAriaLabel": "Category",
    "statusAriaLabel": "Status",
    "totalAmountPlaceholder": "Total amount",
    "totalAmountAriaLabel": "Total amount",
    "currencyAriaLabel": "Currency",
    "costPlaceholder": "Cost",
    "costAriaLabel": "Cost",
    "salePricePlaceholder": "Sale price",
    "salePriceAriaLabel": "Sale price",
    "operationTimePlaceholder": "Operation time",
    "operationTimeAriaLabel": "Operation time",
    "priceTextPlaceholder": "Price (text, e.g. 2.5%)",
    "priceTextAriaLabel": "Price (text)",
    "spaceAriaLabel": "Space",
    "spaceDefaultOption": "{{name}} (active)",
    "cancel": "Cancel",
    "save": "Save"
  },
  "cosmic": {
    "kpis": {
      "generalBalance": "General Balance",
      "currentBalance": "Current Balance",
      "activeLines": "Active Lines",
      "operatingLines": "Lines Operating",
      "suspended": "Suspended",
      "needsAttention": "Needs attention",
      "inventory": "Inventory",
      "inactiveChips": "Inactive chips",
      "history": "History",
      "operations": "Operations"
    },
    "actions": {
      "newActivation": "New Activation",
      "recharge": "Recharge",
      "portability": "Portability"
    },
    "historyTable": {
      "date": "Date",
      "line": "Line",
      "description": "Description",
      "event": "Event",
      "empty": "No recent events"
    },
    "linesTable": {
      "line": "Line",
      "titular": "Holder",
      "plan": "Plan",
      "status": "Status",
      "date": "Date",
      "consumption": "Consumption",
      "action": "Action",
      "empty": "No lines found",
      "noName": "No name",
      "noPlan": "No plan",
      "inactive": "INACTIVE",
      "activeStatus": "Active",
      "loadingDate": "Loading date...",
      "days": "days",
      "gbLeft": "GB left",
      "messagesAriaLabel": "Messages",
      "moreActionsAriaLabel": "More actions"
    },
    "pagination": {
      "previous": "Previous",
      "next": "Next",
      "page": "Page {{current}} of {{total}}"
    }
  },
  "cosmicClient": {
    "titles": {
      "newActivation": "New Activation",
      "recharge": "Recharge",
      "portability": "Portability"
    },
    "noName": "No name",
    "messageTooltip": "Message",
    "rechargeButton": "Recharge Now",
    "tabForm": "Form",
    "tabClient": "Client",
    "noNumber": "No number",
    "clientSince": "Client since",
    "lifecycle": {
      "prospect": "Prospect",
      "lineShipping": "Line Shipping",
      "active": "Active",
      "portability": "Portability",
      "debt": "Debt",
      "preDeactivation": "Pre-deactivation",
      "deactivated": "Deactivated"
    },
    "currentPlan": "Current plan",
    "perMonth": "/ month",
    "renewal": "Renewal",
    "nextMonth": "Next month",
    "monthlyConsumption": "Monthly usage",
    "data": "Data",
    "minutes": "Minutes",
    "sms": "SMS",
    "unlimited": "Unlimited",
    "commentsTitle": "Client Comments"
  },
  "cosmicPurchases": {
    "title": "Recharge balance",
    "subtitle": "Recharge balance to a number in our ecosystem.",
    "numberLabel": "Number to recharge",
    "numberPlaceholder": "Enter the 10 digits",
    "planLabel": "Choose a plan",
    "successTitle": "Recharge successful",
    "successMessage": "The balance has been applied to the line.",
    "close": "Close",
    "errorTitle": "We're experiencing issues",
    "errorMessage": "Please try again later.",
    "retry": "Retry",
    "totalToPay": "Total to pay",
    "processing": "Processing...",
    "recharge": "Recharge"
  },
  "detailPanel": {
    "copyLinkTitle": "Copy link",
    "operationFallback": "Operation",
    "closeAriaLabel": "Close",
    "tabs": {
      "flow": "Flow",
      "config": "Settings",
      "comments": "Comments"
    },
    "comments": {
      "placeholder": "Write a comment...",
      "send": "Send",
      "empty": "No comments yet",
      "unknownUser": "User"
    },
    "whatsappPanelTitle": "WhatsApp Panel",
    "flowMenu": {
      "client": "Client",
      "structure": "Structure",
      "operator": "Operator",
      "document": "Document",
      "trigger": "Trigger",
      "stage": "Stage"
    },
    "flowSearchPlaceholder": "Search...",
    "flowDropdownSearchAriaLabel": "Search in flow menu",
    "flowAdd": "+ Add",
    "flowSearchAriaLabel": "Search node in flow",
    "runFlowTitle": "Run flow",
    "deleteNodeTitle": "Delete",
    "deleteNodeAriaLabel": "Delete node",
    "editNodeTitle": "Edit",
    "editNodeAriaLabel": "Edit node",
    "configPlaceholder": "Settings",
    "comingSoon": "Coming soon"
  },
  "industryInput": {
    "ariaLabel": "Operation industry"
  }
}
